module.exports = ".col-md-4, .col-md-2, .col-md-3 {\n    padding-bottom: 10px;\n}\n\n.ui-dialog .ui-dialog-content {\n    width: 50% !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/usuario/usuario.component.css
// module id = ./src/app/usuario/usuario.component.css
// module chunks = main